import React from 'react'
import { Card, AuthorImage } from '../../../atoms'

interface AuthorDetails {
  quote: string
  imgUrl: string
  authorName: string
  authorDesg: string
  authorUrl: string
}

export interface AuthorSnippetProps {
  name: string
  brand: string
  jsonBody: AuthorDetails
}

const AuthorSnippet = ({ jsonBody, name, brand }: AuthorSnippetProps) => {
  try {
    return (
      <Card variant='modal'>
        <div className='author-snippet' id={name}>
          <div className='author-snippet__content'>
            <div className='author-snippet__content__quote'>
              <span className='author-snippet__content__quote__text'>“{jsonBody.quote}”</span>
            </div>
            <div className='author-snippet__content__author'>
              <div className='author-snippet__content__author__details'>
                <div className='author-snippet__content__author__details__mask'>
                  <AuthorImage
                    src={jsonBody.imgUrl}
                    variant={brand === 'confused' ? 'large' : 'small'}
                  />
                </div>
                <div className='author-snippet__content__author__details__text'>
                  <a
                    className='author-snippet__content__author__details__text__name'
                    href={jsonBody.authorUrl}
                  >
                    {jsonBody.authorName}
                  </a>
                  <div className='author-snippet__content__author__details__text__designation'>
                    {jsonBody.authorDesg}
                  </div>
                  {brand === 'confused' && (
                    <div>
                      <img
                        src='/fs-core-assets/icons/confused/confused.svg'
                        style={{ width: '112px' }}
                        alt='brand-logo'
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
    )
  } catch (error) {
    return <></>
  }
}

export default AuthorSnippet
